export default __webpack_public_path__ + "static/media/google-play.519dfa61.png";